module.exports = __webpack_public_path__ + "img/appypie.e13945d7.png";